import React from 'react'
import styled from 'styled-components'
import { pxToRem } from '../utils'
import exoLogo from '../assets/logos/exo.svg'

const logoClientUrl = process.env.REACT_APP_CLIENT_LOGO_URL
const nameClient = process.env.REACT_APP_CLIENT_NAME

const Wrapper = styled.img`
  max-width: 100%;
  display: inline-block;
  width: ${props => props.width ? `${pxToRem(props.width)}` : 'auto'};
  height: ${props => props.height ? `${pxToRem(props.height)}` : 'auto'};
  object-fit: contain;
  text-align: left;
  font-family: 'Open Sans', sans-serif;
  color: #5b666d;
  font-size: ${pxToRem(13)};
`

const Logo = props => {
  const { width, name, alt, src, ...rest } = props;
  if (name === 'client') {
    return <Wrapper width={width} src={logoClientUrl} alt={nameClient} title={nameClient} {...rest} />
  } else if (name === 'exo') {
    return <Wrapper width={width} src={exoLogo} alt="Logo Exo" title="Exo Excelência Organizacional" {...rest} />
  } else {
    return <Wrapper width={width} {...rest} alt={'Falha ao carregar imagem'} style={{ outline: '1px solid #d8d8d8' }} />
  }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo.js